export function loginSuccess(dispatch, authUser) {
  dispatch({type: 'LOGIN_SUCCESS', payload: authUser})
}

export function logout(dispatch) {
  dispatch({type: 'LOGOUT'});
}
